export default __webpack_public_path__ + "audacity.0b07a25a.png";